import React from 'react';
import UncomposedEdit from './UnComposedEdit';
import {
  EditPageContainer,
  withServerErrors,
  withResolver,
  withDebug,
} from 'components/common';
import { compose, withState, withProps } from 'recompose';

const enhance = compose(
  withServerErrors(),
  withProps(props => {
    const arr = props.history.location.pathname.split('/');
    return {
      options: 'installer=' + arr[2]
    }
  }),
  EditPageContainer({
    url: 'installer-users',
    convertServerErrors: ['password', 'email'],
    defaultItem: {
      is_active: false,
      role: 20
    },
  }),
  withState('serverErrors', 'setServerErrors', {}),
);

export default enhance(UncomposedEdit);



// WEBPACK FOOTER //
// ./src/pages/Users/NewInstallerUser.jsx